const config = {
  apiBaseUrl: process.env.REACT_APP_APIBASEURL,
  rcApiBaseUrl: process.env.REACT_APP_RINGCENTRAL_API_BASE_URL,
  rc_client_Id: process.env.REACT_APP_RINGCENTRAL_CLIENT_ID,
  rc_authorize_uri: process.env.REACT_APP_RINGCENTRAL_AUTHORIZE_URI,
  rc_jwks_url: process.env.REACT_APP_JWKS_URL,
  jwksAppName: {
    production: process.env.REACT_APP_JWKS_APP_NAME,
    sandBox: process.env.REACT_APP_JWKS_SANDBOX_APPNAME,
  },
	voicemailNumber: process.env.REACT_APP_RINGCENTRAL_VOICEMAIL_NUMBER,
	voicemailAccountUID: process.env.REACT_APP_RINGCENTRAL_VOICEMAIL_ACCOUNT_UID,
	voicemailExtensionID: process.env.REACT_APP_RINGCENTRAL_VOICEMAIL_EXTENSION_ID,
};

module.exports = config;